export default __webpack_public_path__ + "2025 Spontaneous single-molecule dissociation in infrared nanocavities.pdf";